import { createConsumer } from '@rails/actioncable'

let consumer = null

export function getConsumer() {
  if (!consumer) {
    consumer = createConsumer()
  }
  return consumer
}

export function subscribeToNeurons(onReceived, onReconnected) {
  const subscription = getConsumer().subscriptions.create('NeuronsChannel', {
    received: onReceived,
    connected() {
      if (subscription._wasDisconnected && onReconnected) {
        onReconnected()
      }
    },
    disconnected() {
      subscription._wasDisconnected = true
    },
  })
  return subscription
}
